
export const GET_CLIENT_RECENT_ACTIVITIES = "GET_CLIENT_RECENT_ACTIVITIES";
export const GET_CLIENT_RECENT_ACTIVITIES_SUCCESS = "GET_CLIENT_RECENT_ACTIVITIES_SUCCESS";
export const GET_CLIENT_RECENT_ACTIVITIES_FAIL = "GET_CLIENT_RECENT_ACTIVITIES_FAIL";


export const GET_CLIENT_UPCOMING_ACTIVITIES = "GET_CLIENT_UPCOMING_ACTIVITIES";
export const GET_CLIENT_UPCOMING_ACTIVITIES_SUCCESS = "GET_CLIENT_UPCOMING_ACTIVITIES_SUCCESS";
export const GET_CLIENT_UPCOMING_ACTIVITIES_FAIL = "GET_CLIENT_UPCOMING_ACTIVITIES_FAIL";
